import { AnyAction } from "redux";
import { SET_KPIS_LOADED } from "../actions/loadingKpis";

export const loadingKpis = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_KPIS_LOADED:
      return action.kpisLoaded;
    default:
      return state;
  }
};

export default loadingKpis;
